import { render, staticRenderFns } from "./RecordAnswer.vue?vue&type=template&id=6e3ed567&scoped=true&"
import script from "./RecordAnswer.vue?vue&type=script&lang=js&"
export * from "./RecordAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ed567",
  null
  
)

export default component.exports